<template>
  <div class="amazon">
    <Header />
    <div class="paypal-main">
      <RewardsChild :rewardsChildData="rewardsChildData"></RewardsChild>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import RewardsChild from "./mycom/rewardsChild.vue";
import { paypal } from "@/utlis/storageData.js";
export default {
  components: { Header, Footer, RewardsChild },
  data() {
    return {
      rewardsChildData: paypal,
    };
  },
};
</script>
<style scoped>
.amazon {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.paypal-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
}
</style>


// WEBPACK FOOTER //
// src/components/paypal.vue